import { reducerTypes } from './types';
import { InstaMediaType } from '../../react-pages/ServicePage/WorkshopPhotos/types';

export const getInstaMediaAction = (data: InstaMediaType[]) => ({
  type: reducerTypes.GET_ALL_INSTA_MEDIA,
  payload: data,
});
